module.exports = __webpack_public_path__ + "img/color-preview.d7ef72da.svg";